import React, { useMemo, useEffect, useState } from "react";
import { useWindowScroll } from "react-use";
import { useLocation, Link } from "react-router-dom";
import classnames from "classnames";
import qs from "qs";
import jwt from "jsonwebtoken";
import { useTranslation } from "react-i18next";
// import { Notice } from "../Notice";
import { CommonConsult } from "../../blocks/common-consult";
import { MobileHeader } from "../../components/MobileHeader";
import { DownloadLogoFile } from "../../components/DownloadLogoFile";
import { getDefaultLang, tryNow, langs, userLogout } from "../../utils";
import { useCsdnLogin } from "./useCsdnLogin";
import { host } from "../../config/openapi";

import "./styles.less";
import { Notice } from "../Notice";
const defaultLang = getDefaultLang();

export const Header = (props) => {
  const {
    mode = "dark",
    defaltNav = false,
    isMobile,
    hasNotice = true,
    special = false,
  } = props;
  const { y = 0 } = useWindowScroll();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("");
  const [user, setUser] = useState(null);
  // const [currentClient, currentView, mobileFooter, mobileHeader] = useClient();
  // const { state } = useGlobalContext();
  const [isDownloadLogoFileShow, setIsDownloadLogoFileShow] = useState(false);
  const { i18n, t } = useTranslation();

  const menu = [
    {
      title: `${t("common.nav.nav-product")}`,
      key: "product",
      // url: "/product",
      subMenuStyle: {
        left: -100,
      },
      children: [
        {
          type: t("common.nav.nav-type-staff"),
          submenus: [
            // {
            //   title: t("common.common.product-identity"),
            //   url: "/identity-automation",
            // },
            {
              title: t("common.common.product-sso"),
              url: "/learn/sso",
            },
            {
              title: t("common.common.product-authority"),
              url: "/authorization-management",
            },
            {
              title: t("common.common.product-tenant"),
              url: "/multi-tenant",
            },
            {
              title: `${t("common.common.product-mfa")}`,
              url: "/mfa",
            },
            {
              title: t("common.common.product-verify"),
              url: "/verify",
            },
            {
              title: t("common.common.product-gateway-integration"),
              url: "/gateway-integration",
            },
          ],
        },
        {
          type: t("common.nav.nav-type-user"),
          submenus: [
            {
              title: t("common.common.product-comp"),
              url: "/learn/guard",
              log: "header/euniversalogin",
            },
            {
              title: t("common.common.product-sso"),
              url: "/learn/sso",
            },
            {
              title: t("common.common.product-verify"),
              url: "/verify",
              log: "header/cmobilexpress",
            },
            {
              title: t("common.common.product-mfa"),
              url: "/mfa",
              log: "header/cmfa",
            },
            {
              title: t("common.common.product-database"),
              url: "/database-connection",
              log: "header/cdatabase",
            },
          ],
        },
      ],
    },
    {
      title: `${t("common.nav.nav-solution")}`,
      key: "solution",
      // url: "/solution",
      children: [
        {
          type: `${t("common.nav.nav-type-industry")}`,
          line: true,
          submenus: [
            {
              imgIcon: "nav-manufacture.svg",
              title: `${t("common.nav.nav-solution-manufacture")}`,
              url: "/solutions/manufacturing",
              log: "header/manufacture",
            },
            {
              imgIcon: "nav-icon-finance.png",
              title: `${t("common.nav.nav-solution-finance")}`,
              url: "/solutions/finance",
              log: "header/finance",
            },
            {
              imgIcon: "nav-icon-automotive.svg",
              title: `${t("common.nav.nav-solution-cars")}`,
              url: "/solutions/automotive",
            },

            {
              imgIcon: "nav-icon-government.png",
              title: `${t("common.nav.nav-solution-government")}`,
              url: "/solutions/government",
              log: "header/gov",
            },
            {
              imgIcon: "nav-icon-medical.png",
              title: `${t("common.nav.nav-solution-medical")}`,
              url: "/solutions/medical",
              log: "header/healthcare",
            },
            {
              imgIcon: "nav-icon-education-new.png",
              title: `${t("common.nav.nav-solution-education")}`,
              url: "/solutions/education",
              log: "header/edu",
            },
            {
              imgIcon: "nav-icon-enterprise.png",
              title: `${t("common.nav.nav-solution-software")}`,
              url: "/solutions/software",
              log: "header/tech",
            },
            {
              imgIcon: "nav-icon-game.png",
              title: `${t("common.nav.nav-solution-game")}`,
              url: "/solutions/game",
              log: "header/game",
            },
            {
              imgIcon: "nav-icon-publisher.png",
              title: `${t("common.nav.nav-solution-publisher")}`,
              url: "/solutions/publisher",
              log: "header/publish",
            },
            {
              imgIcon: "nav-icon-consume.png",
              title: `${t("common.nav.nav-solution-consume")}`,
              url: "/solutions/consume",
              log: "header/retail",
            },
            {
              imgIcon: "nav-icon-software-new.png",
              title: `${t("common.nav.nav-solution-enterprise")}`,
              url: "/solutions/enterprise",
              log: "header/sass",
            },
          ],
        },
        {
          type: `${t("common.nav.nav-type-scense")}`,
          submenus: [
            {
              title: `${t("common.nav.nav-solution-wechat")}`,
              url: "/solutions/wechat",
              tag: "tag",
              log: "header/wechateco",
            },
            {
              title: `${t("common.nav.nav-solution-idaas")}`,
              url: "/solutions/idaas",
              log: "header/newidaas",
            },
            {
              title: `${t("common.nav.nav-solution-ad")}`,
              url: "/solutions/ad",
            },
            {
              title: `${t("common.nav.nav-solution-okta")}`,
              url: "/solutions/okta",
              log: "header/vsokta",
            },
            {
              title: `${t("common.nav.nav-solution-build-idaas")}`,
              url: "/solutions/build-idaas",
              log: "header/newiam",
            },
            {
              title: `${t("common.nav.nav-solution-cognito")}`,
              url: "/solutions/cognito",
              log: "header/vsaws",
            },
            {
              title: `${t("common.nav.nav-solution-keycloak")}`,
              url: "/solutions/keycloak",
              log: "header/vskeycloak",
            },
            {
              title: `${t("common.nav.nav-solution-auth0")}`,
              url: "/solutions/auth0",
            },
          ],
        },
      ],
    },
    {
      title: t("common.nav.nav-case"),
      key: "case",
      url: "/customer",
      log: "header/cases",
      subMenuStyle: {
        left: -250,
      },
      children: [
        {
          type: t("common.nav.nav-type-customer"),
          submenus: [
            {
              imgCustomerIcon: "customer-icon-hep.png",
              title: t("common.nav.nav-customer-hep"),
              url: "/customer/hep",
              log: "header/higheredu",
              // descript: `${t("common.nav.nav-developer-document-descript")}`,
            },
            {
              imgCustomerIcon: "customer-icon-cnpn.png",
              title: t("common.nav.nav-customer-cnpn"),
              url: "/customer/cnpn",
              log: "header/cnpetro",
              // descript: `${t("common.nav.nav-developer-document-descript")}`,
            },
            {
              imgCustomerIcon: "customer-icon-southeast.png",
              title: t("common.nav.nav-customer-southeast-university"),
              url: "/customer/southeast-university",
              log: "header/southeastcollege",
              // descript: `${t("common.nav.nav-developer-document-descript")}`,
            },
            {
              imgCustomerIcon: "customer-icon-nreal.png",
              title: t("common.nav.nav-customer-nreal"),
              url: "/customer/nreal",
              // descript: `${t("common.nav.nav-developer-document-descript")}`,
            },
            // {
            //   link: t("common.nav.learn-more"),
            //   url: "/customer",
            // },
          ],
        },
        {
          type: " ",
          submenus: [
            {
              imgCustomerIcon: "customer-icon-yuanqi.png",
              title: t("common.nav.nav-customer-yuanqi"),

              url: "/customer/yuanqi",
              log: "header/yuanqi",
              // descript: `${t("common.nav.nav-developer-document-descript")}`,
            },
            {
              imgCustomerIcon: "customer-icon-volks.png",
              title: t("common.nav.nav-customer-volkswagen"),
              url: "/customer/volkswagen",
              log: "header/volkswagen",
            },
            {
              imgCustomerIcon: "customer-icon-jcdecaux.png",
              title: t("common.nav.nav-customer-jcdecaux"),
              url: "/customer/jcdecaux",
              log: "header/jcdecaux",
            },

            // {
            //   imgCustomerIcon: "customer-icon-coca-cola.png",
            //   title: t("common.nav.nav-customer-cocacola"),
            //   url: "/customer/coca-cola",
            // },
          ],
        },
      ],
    },
    {
      title: `${t("common.nav.nav-developer")}`,
      key: "developer",
      url: "/developer",
      log: "header/developer",
      subMenuStyle: {
        left: -390,
      },
      children: [
        {
          type: `${t("common.nav.nav-type-developer-social")}`,
          submenus: [
            {
              icon: "icon authing-icon authing-question-answer-line",
              title: `${t("common.nav.nav-developer-community")}`,
              url: "/develop-community",
              log: "header/forum",
              descript: `${t("common.nav.nav-developer-community-descript")}`,
            },
            {
              icon: "icon authing-icon authing-bookmark-3-line",
              title: t("common.nav.nav-developer-blog"),
              url: "/blog",
              log: "header/blog",
              descript: `${t("common.nav.nav-developer-blog-descript")}`,
            },
          ],
        },
        {
          type: `${t("common.nav.nav-type-developer-resource")}`,

          submenus: [
            {
              icon: "icon authing-icon authing-file-list-3-line",
              title: `${t("common.nav.nav-developer-document")}`,
              url: "/doc",
              log: "header/doc",
              descript: `${t("common.nav.nav-developer-document-descript")}`,
            },
            {
              icon: "icon authing-icon authing-api1",
              title: `${t("common.nav.nav-developer-api")}`,
              url: "/api",
              log: "header/api",
              descript: t("common.nav.nav-developer-api-descript"),
            },
          ],
        },
      ],
    },
    {
      title: `${t("common.nav.nav-price")}`,
      key: "pricing",
      url: "/pricing",
      log: "header/pricing",
    },
    {
      title: `${t("common.nav.nav-abuoutus")}`,
      key: "about",
      url: "/about",
      log: "header/about",
      subMenuStyle: {
        left: -450,
      },
      children: [
        {
          type: t("common.nav.nav-type-about"),
          submenus: [
            {
              aboutIcon: "icon authing-icon authing-building-line",
              title: `${t("common.nav.nav-company-intro")}`,
              url: "/about",
              log: "header/intro",
            },
            {
              aboutIcon: "icon authing-icon authing-timer-2-line",
              title: t("common.nav.nav-timeline"),
              url: "/changelog",
              log: "header/timeline",
            },
            {
              aboutIcon: "icon authing-icon authing-team-line",
              title: `${t("common.footer.footer-company-joinus")}`,
              url: "/joinus",
              log: "header/career",
              job: t("common.nav.nav-tag-joinus"),
            },
            {
              aboutIcon: "icon authing-icon authing-hand-coin-line",
              title: `${t("common.footer.footer-network")}`,
              url: "/partner",
              log: "header/partner",
              tag: "tag",
            },
          ],
        },
      ],
    },
    // {
    //   title: t("common.nav.nav-demo"),
    //   key: "Demo",
    //   url: "https://democenter.authing.cn/GRLuJqxD",
    //   log: "header/Demo",
    // },
  ];

  useEffect(() => {
    const _pathname = location.pathname;
    menu.forEach((m) => {
      const selectedSubPath = m.children?.map((child) => {
        return child.submenus.some((sub) => sub.url === _pathname);
      });
      if (m.url === _pathname) {
        setActiveKey(m.key);
      } else if (selectedSubPath?.some((path) => path === true)) {
        setActiveKey(m.key);
      }
      if (_pathname === "/joinus") {
        setActiveKey("about");
      }
      if (_pathname === "/security") {
        setActiveKey("product");
      }
    });
  }, [location, menu]);

  useEffect(() => {
    if (user) {
      _MEIQIA("metadata", {
        name: user?.nickname,
        tel: user?.phone_number,
        email: user?.email,
      });
    }
  }, [user]);

  const clssmode = useMemo(() => {
    if (special) {
      return "header backgroud fixed";
    } else {
      return classnames({
        header: true,
        "header-dark": mode === "dark",
        "header-light": mode === "light" && y < 10,
        backgroud: y > 10 || defaltNav,
        // fixed: y > 34,
        fixed: hasNotice ? y > 34 : true,
        // fixed: true,
      });
    }
  }, [defaltNav, hasNotice, mode, special, y]);

  const setCookieLang = (lang) => {
    const topLevelDomain = window.location.hostname
      .split(".")
      .slice(-2)
      .join(".");
    document.cookie = `_authing_lang=${lang}; path=/; domain=${topLevelDomain}`;
  };

  const change = (event) => {
    const _lang = event.target.value;
    i18n.changeLanguage(_lang);
    setCookieLang(_lang);
    window.location.reload();
  };
  const [lang] = useState(defaultLang);
  const onPageClickLink = (sub) => {
    if (sub.url === "/doc") {
      // window.open("https://docs.authing.cn/v2/", "_blank");
      return (
        <a
          className="sub-item"
          href={
            i18n.language === "zh-CN"
              ? "https://docs.authing.cn/"
              : "https://docs.authing.cn/en/"
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sub-icon">
            <i className={sub.icon}></i>
          </span>
          <div>
            {sub.title}
            <span className="arrow">
              <i className="icon authing-icon authing-arrow-right-line"></i>
            </span>
            {sub.descript && (
              <div className="sub-item-descirpt">{sub.descript}</div>
            )}
          </div>
        </a>
      );
    } else if (sub.url === "/customer-sucess") {
      // window.open("//files.authing.co/authing-website/authing-customer-success.pdf", "_blank");
      return (
        <a
          className="sub-item"
          href="//files.authing.co/authing-website/authing-customer-success-new.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sub-icon">
            <i className={sub.icon}></i>
          </span>
          {sub.title}
          <span className="arrow">
            <i className="icon authing-icon authing-arrow-right-line"></i>
          </span>
        </a>
      );
    } else if (sub.url === "/develop-community") {
      // window.open("//gitter.im/authing-chat/community");
      return (
        <a
          className="sub-item"
          href="//forum.authing.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sub-icon">
            <i className={sub.icon}></i>
          </span>
          <div>
            {sub.title}
            <span className="arrow">
              <i className="icon authing-icon authing-arrow-right-line"></i>
            </span>
            {sub.descript && (
              <div className="sub-item-descirpt">{sub.descript}</div>
            )}
          </div>
        </a>
      );
    } else if (sub.url === "/api") {
      // window.open("//gitter.im/authing-chat/community");
      return (
        <div className="sub-item-api">
          <a
            className="sub-item"
            href={`${host}?source=Authing%20%E7%94%A8%E6%88%B7%E8%AE%A4%E8%AF%81%20API`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="sub-icon">
              <i className={sub.icon}></i>
            </span>
            <div>
              {t("common.nav.nav-developer-api-user")}
              <span className="arrow">
                <i className="icon authing-icon authing-arrow-right-line"></i>
              </span>
              {sub.descript && (
                <div className="sub-item-descirpt">
                  {t("common.nav.nav-developer-api-user-des")}
                </div>
              )}
            </div>
          </a>
          <a
            className="sub-item"
            href={`${host}?source=Authing%20%E7%AE%A1%E7%90%86%20API`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="sub-icon sub-item-api-icon">
              <i className={sub.icon}></i>
            </span>
            <div>
              {t("common.nav.nav-developer-api-manage")}
              <span className="arrow">
                <i className="icon authing-icon authing-arrow-right-line"></i>
              </span>
              {sub.descript && (
                <div className="sub-item-descirpt">
                  {t("common.nav.nav-developer-api-manage-des")}
                </div>
              )}
            </div>
          </a>
        </div>
      );
    } else {
      return (
        <Link className="sub-item" to={sub.url}>
          {sub.aboutIcon && (
            <span className="sub-about-icon">
              <i className={sub.aboutIcon}></i>
            </span>
          )}
          {sub.icon && (
            <span className="sub-icon">
              <i className={sub.icon}></i>
            </span>
          )}
          {sub.imgIcon && (
            <span className="sub-img-icon">
              <img
                src={`//files.authing.co/authing-website/${sub.imgIcon}`}
                alt="authing"
              />
            </span>
          )}
          {sub.imgCustomerIcon && (
            <span className="sub-img-customer-icon">
              <img
                src={`//files.authing.co/authing-website/${sub.imgCustomerIcon}`}
                alt="authing"
              />
            </span>
          )}
          {/* style={{ marginRight: sub.job ? -50 : "" }} */}
          <div>
            {sub.title}
            {sub.tag && (
              <i
                className="icon authing-icon authing-hot2"
                style={{ color: "#E63333", fontSize: 15, marginLeft: 4 }}
              ></i>
            )}
            {sub.job && <span className="jobTag">{sub.job}</span>}
            {sub.link && <span className="sub-item-link">{sub.link}</span>}
            <span>{sub.hotTag}</span>
            <span className="arrow">
              <i className="icon authing-icon authing-arrow-right-line"></i>
            </span>
            {sub.descript && (
              <div className="sub-item-descirpt">{sub.descript}</div>
            )}
          </div>
        </Link>
      );
    }
  };

  const { isToCsdn, toCsdnUrl } = useCsdnLogin();

  useEffect(() => {
    const getUser = async () => {
      const { consoleHost, appId } = window._AUTHING__GLOBAL_CONFIG_;
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = `${consoleHost}/oidc/auth?${qs.stringify({
        app_id: appId,
        client_id: appId,
        redirect_uri: `${consoleHost}/console/userpool/frontend/callback`,
        response_type: "id_token",
        state: +new Date(),
        nonce: +new Date(),
        scope: "openid profile phone email",
        prompt: "none",
      })}`;

      document.body.append(iframe);

      window.addEventListener("message", function handleLogin(evt) {
        try {
          const { event, data } = JSON.parse(evt.data);
          if (
            event.source === "authing" &&
            ["idTokenFromOidc", "idTokenFromLocalStorage"].includes(
              event.eventType
            )
          ) {
            if (data.token) {
              const user = jwt.decode(data.token);

              setUser(jwt.decode(data.token));

              window.__user__ = user;
            }

            window.removeEventListener(handleLogin);
          }
        } catch (e) {
          // do nothing
        }
      });
    };

    isToCsdn
      ? typeof window !== "undefined" && window.location.replace(toCsdnUrl)
      : getUser();
  }, [isToCsdn, toCsdnUrl]);

  const handleLogout = async () => {
    await userLogout();

    window.location.reload();
  };

  const avatarImg =
    user?.picture ||
    user?.photo ||
    "//files.authing.co/authing-website/icon-user-identity.svg";

  const renderCaseExtra = () => {
    return (
      <div className="case-extra">
        <div className="case-extra-box">
          <div className="case-img">
            <img
              src="//files.authing.co/authing-website/nav-case-img.png"
              alt="authing"
            />
          </div>
          <div className="case-description">
            {t("common.nav.nav-case-description")}
          </div>
        </div>
      </div>
    );
  };
  const renderAboutExtra = () => {
    return (
      <div className="about-extra">
        <a className="nav-link" href="/apn">
          <div className="about-extra-box">
            <div className="title">
              {/* <span style={{ color: "#215ae5", marginRight: 4 }}>
              <i className="icon authing-icon authing-lejiebeifen"></i>
            </span> */}
              {t("common.nav.nav-type-APN")}
            </div>
            <a style={{ fontSize: 12 }}>
              {t("common.check")}
              <i
                className="icon authing-icon authing-arrow-right-line"
                style={{ fontSize: 12 }}
              ></i>
            </a>
            <div className="about-img">
              <img src={t("common.nav.nav-type-APN-img")} alt="authing" />
            </div>
          </div>
        </a>
      </div>
    );
  };

  const renderDeveloperExtra2 = () => {
    return (
      <div className="developer-extra">
        <div className="title">{t("common.nav.nav-developer-doclink")}</div>
        <div className="developer-extra-block-warp">
          <a
            className="developer-extra-block-getstart"
            href="https://docs.authing.cn/v2/quickstarts/"
            rel="noopener noreferrer"
            target="_blank"
            data-log="header/quickstartdoc"
          >
            <div className="icon-img">
              <i className="icon authing-icon authing-play-line"></i>
            </div>
            <div className="developer-title link">
              <span>{t("common.nav.nav-developer-extra-start")}</span>
              <span className="arrow">
                <i className="icon authing-icon authing-arrow-right-line"></i>
              </span>
            </div>
          </a>
          <a
            className="developer-extra-block-pipeline"
            href="//docs.authing.cn/v2/guides/pipeline/"
            rel="noopener noreferrer"
            target="_blank"
            data-log="header/pipeline"
          >
            <div className="icon-img">
              <i className="icon authing-icon authing-flow-chart1"></i>
            </div>
            <div className="developer-title link">
              <span>{t("common.nav.nav-developer-extra-pipeline")}</span>
              <span className="arrow">
                <i className="icon authing-icon authing-arrow-right-line"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    );
  };
  const renderProductExtra = () => {
    return (
      <div className="product-extra">
        <div className="title">{t("common.nav.nav-type-service")}</div>
        {/* <div className="link-item">
          <div className="icon">
            <img
              src="//files.authing.co/authing-website/nav-product-success-icon.svg"
              alt="authing"
            />
          </div>
          <a
            className="link-text-warp"
            href="//files.authing.co/authing-website/authing-customer-success-new.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-log="header/csm"
          >
            <div className="link-name">
              {t("common.nav.nav-customer-success")}
            </div>
          </a>
        </div> */}
        <div className="link-item">
          <div className="icon">
            <img
              src="//files.authing.co/authing-website/nav-product-security-icon.svg"
              alt="authing"
            />
          </div>
          <Link
            className="link-text-warp"
            to="/security"
            data-log="header/compliance"
          >
            <div className="link-name">
              {t("common.common.product-security")}
            </div>
            {/* <div className="link-descript">
              {t("common.nav.nav-developer-document-descript")}
            </div> */}
          </Link>
        </div>
        <div className="link-item">
          <div className="icon">
            <img
              src="//files.authing.co/authing-website/marketplace-icon-new.png"
              alt="authing"
            />
          </div>
          <Link className="link-text-warp" to="/apn" data-log="header/apn">
            <div className="link-name">
              {t("common.nav.nav-marketplace")}
              <i
                className="icon authing-icon authing-hot2"
                style={{ color: "#E63333", fontSize: 15, marginLeft: 4 }}
              ></i>
            </div>
            {/* <div className="link-descript">
              {t("common.nav.nav-developer-document-descript")}
            </div> */}
          </Link>
        </div>
        <div className="link-item">
          <div className="icon">
            <img
              src="//files.authing.co/authing-website/nav-product-cloud-native-icon.png"
              alt="authing"
            />
          </div>
          <Link
            className="link-text-warp"
            to="/cloud-native"
            data-log="header/cloudnative"
          >
            <div className="link-name">{t("common.nav.nav-cloud-native")}</div>
            {/* <div className="link-descript">
              {t("common.nav.nav-developer-document-descript")}
            </div> */}
          </Link>
        </div>
      </div>
    );
  };

  const renderSolutionExtra = () => {
    return (
      <div className="solution-extra">
        <a className="nav-link">
          <div className="title">{t("common.nav.nav-type-application")}</div>
        </a>
        <a className="nav-link">
          <div className="description">
            {t("common.nav.nav-solution-extra-subtitle")}
          </div>
        </a>
        <div className="solution-img">
          <a className="nav-link">
            <img
              src="//files.authing.co/authing-website/nav-solution-img-new.png"
              alt=""
            />
          </a>
        </div>
      </div>
    );
  };

  const menuMobile = [
    // {
    //   title: `${t("common.nav.nav-ROI")}`,
    //   key: "ROI",
    //   url: "https://host.huiju.cool/p/b1e3e",
    // },
    {
      title: `${t("common.nav.nav-product")}`,
      key: "product",
      children: [
        {
          icon: "authing-user-2-line",
          type: t("common.nav.nav-type-staff"),
          submenus: [
            {
              title: t("common.common.product-sso"),
              url: "/learn/sso",
            },
            {
              title: t("common.common.product-tenant"),
              url: "/multi-tenant",
            },
            {
              title: `${t("common.common.product-mfa")}`,
              url: "/mfa",
            },
            {
              title: t("common.common.product-verify"),
              url: "/verify",
            },
            {
              title: t("common.common.product-gateway-integration"),
              url: "/gateway-integration",
            },
            {
              title: t("common.common.product-authority"),
              url: "/authorization-management",
            },
          ],
        },
        {
          icon: "authing-user-line1",
          type: t("common.nav.nav-type-user"),
          submenus: [
            {
              title: t("common.common.product-comp"),
              url: "/learn/guard",
            },
            {
              title: t("common.common.product-sso"),
              url: "/learn/sso",
            },
            {
              title: t("common.common.product-verify"),
              url: "/verify",
            },
            {
              title: t("common.common.product-mfa"),
              url: "/mfa",
            },
            {
              title: t("common.common.product-database"),
              url: "/database-connection",
            },
          ],
          productExtra: [
            // {
            //   icon:
            //     "//files.authing.co/authing-website/nav-product-success-icon-mobile.svg",
            //   title: t("common.nav.nav-customer-success"),
            //   url:
            //     "//files.authing.co/authing-website/authing-customer-success-new.pdf",
            // },
            {
              icon:
                "//files.authing.co/authing-website/nav-product-security-icon-mobile.svg",
              title: t("common.common.product-security"),
              url: "/security",
            },
            {
              icon:
                "//files.authing.co/authing-website/nav-product-apn-icon-mobile.svg",
              title: t("common.nav.nav-marketplace"),
              url: "/apn",
            },
            {
              icon:
                "//files.authing.co/authing-website/nav-product-cloud-native-icon.png",
              title: t("common.nav.nav-cloud-native"),
              url: "/cloud-native",
            },
          ],
        },
      ],
    },
    {
      title: `${t("common.nav.nav-solution")}`,
      key: "solution",
      // url: "/solution",
      children: [
        {
          icon: "authing-briefcase-2-line",
          type: `${t("common.nav.nav-type-industry")}`,
          line: true,
          submenus: [
            {
              imgIcon: "nav-icon-finance.png",
              title: `${t("common.nav.nav-solution-finance")}`,
              url: "/solutions/finance",
            },
            {
              imgIcon: "nav-icon-government.png",
              title: `${t("common.nav.nav-solution-government")}`,
              url: "/solutions/government",
            },
            {
              imgIcon: "nav-icon-medical.png",
              title: `${t("common.nav.nav-solution-medical")}`,
              url: "/solutions/medical",
            },
            {
              imgIcon: "nav-icon-education-new.png",
              title: `${t("common.nav.nav-solution-education")}`,
              url: "/solutions/education",
            },
            {
              imgIcon: "nav-icon-software-new.png",
              title: `${t("common.nav.nav-solution-software")}`,
              url: "/solutions/software",
            },
            {
              imgIcon: "nav-icon-game.png",
              title: `${t("common.nav.nav-solution-game")}`,
              url: "/solutions/game",
            },
            {
              imgIcon: "nav-icon-publisher.png",
              title: `${t("common.nav.nav-solution-publisher")}`,
              url: "/solutions/publisher",
            },
            {
              imgIcon: "nav-icon-consume.png",
              title: `${t("common.nav.nav-solution-consume")}`,
              url: "/solutions/consume",
            },
            {
              imgIcon: "nav-icon-enterprise.png",
              title: `${t("common.nav.nav-solution-enterprise")}`,
              url: "/solutions/enterprise",
            },
          ],
        },
        {
          icon: "authing-task-line",
          type: `${t("common.nav.nav-type-scense")}`,
          submenus: [
            {
              title: `${t("common.nav.nav-solution-wechat")}`,
              url: "/solutions/wechat",
              tag: "tag",
            },
            {
              title: `${t("common.nav.nav-solution-idaas")}`,
              url: "/solutions/idaas",
            },
            {
              title: `${t("common.nav.nav-solution-ad")}`,
              url: "/solutions/ad",
            },
            {
              title: `${t("common.nav.nav-solution-okta")}`,
              url: "/solutions/okta",
            },
            {
              title: `${t("common.nav.nav-solution-build-idaas")}`,
              url: "/solutions/build-idaas",
            },
            {
              title: `${t("common.nav.nav-solution-cognito")}`,
              url: "/solutions/cognito",
            },
            {
              title: `${t("common.nav.nav-solution-keycloak")}`,
              url: "/solutions/keycloak",
            },
            {
              title: `${t("common.nav.nav-solution-auth0")}`,
              url: "/solutions/auth0",
            },
          ],
          solutionExtra: [
            {
              title: t("common.nav.nav-type-application"),
              descript: t("common.nav.nav-solution-extra-subtitle"),
              url:
                "//files.authing.co/authing-website/nav-solution-img-new.png",
            },
          ],
        },
      ],
    },
    {
      title: t("common.nav.nav-case"),
      key: "case",
      url: "/customer",
      children: [
        {
          icon: "authing-chat-smile-2-line",
          type: t("common.nav.nav-type-customer"),
          submenus: [
            {
              imgCustomerIcon: "customer-icon-hep.png",
              title: t("common.nav.nav-customer-hep"),
              url: "/customer/hep",
            },
            {
              imgCustomerIcon: "customer-icon-cnpn.png",
              title: t("common.nav.nav-customer-cnpn"),
              url: "/customer/cnpn",
            },
            {
              imgCustomerIcon: "customer-icon-southeast.png",
              title: t("common.nav.nav-customer-southeast-university"),
              url: "/customer/southeast-university",
            },
            {
              imgCustomerIcon: "customer-icon-yuanqi.png",
              title: t("common.nav.nav-customer-yuanqi"),
              url: "/customer/yuanqi",
            },
            {
              imgCustomerIcon: "customer-icon-volks.png",
              title: t("common.nav.nav-customer-volkswagen"),
              url: "/customer/volkswagen",
            },
            {
              imgCustomerIcon: "customer-icon-nreal.png",
              title: t("common.nav.nav-customer-nreal"),
              url: "/customer/nreal",
            },
            // {
            //   imgCustomerIcon: "customer-icon-coca-cola.png",
            //   title: t("common.nav.nav-customer-cocacola"),
            //   url: "/customer/coca-cola",
            // },
            // {
            //   link: t("common.nav.learn-more"),
            //   url: "/customer",
            // },
          ],
        },
      ],
    },
    {
      title: `${t("common.nav.nav-developer")}`,
      key: "developer",
      children: [
        {
          icon: "authing-server-line",
          key: "developer",
          type: `${t("common.nav.nav-type-developer")}`,
          submenus: [
            {
              title: `${t("common.nav.nav-developer-document")}`,
              url: t("common.nav.nav-docs"),
              urlType: "outlink",
            },
            {
              title: `${t("common.nav.nav-developer-community")}`,
              url: "https://forum.authing.cn",
              urlType: "outlink",
            },
            {
              title: t("common.nav.nav-developer-api"),
              url: "https://www.apifox.cn/apidoc/project-548164/doc-422080",
              urlType: "outlink",
            },
            {
              title: t("common.nav.nav-developer-blog"),
              url: "/blog",
            },
          ],
        },
        {
          icon: "authing-file-list-2-line",
          type: t("common.nav.nav-developer-doclink"),
          key: "developer",
          submenus: [
            {
              title: `${t("common.nav.nav-developer-document")}`,
              url: t("common.nav.nav-docs"),
              urlType: "outlink",
            },
            {
              title: `${t("common.nav.nav-developer-community")}`,
              url: "https://docs.authing.cn/v2/guides/pipeline/",
              urlType: "outlink",
            },
          ],
        },
      ],
    },
    {
      title: `${t("common.nav.nav-price")}`,
      key: "pricing",
      url: "/pricing",
    },
    {
      title: `${t("common.nav.nav-abuoutus")}`,
      key: "about",
      children: [
        {
          icon: "authing-building-line1",
          type: t("common.nav.nav-type-company"),
          submenus: [
            {
              title: `${t("common.nav.nav-company-intro")}`,
              url: "/about",
            },
            {
              title: t("common.nav.nav-timeline"),
              url: "/changelog",
            },
            {
              title: `${t("common.footer.footer-company-joinus")}`,
              url: "/joinus",
              job: t("common.nav.nav-tag-joinus"),
            },
            {
              title: t("common.footer.footer-network"),
              url: "/partner",
              tag: "tag",
            },
          ],
          aboutExtra: {
            title: t("common.nav.nav-type-APN"),
            url: t("common.nav.nav-type-APN-img"),
          },
        },
      ],
    },
    // {
    //   title: t("common.nav.nav-demo"),
    //   key: "Demo",
    //   url: "https://app.doristell.com/demo/GRLuJqxD",
    //   log: "header/Demo",
    // },
  ];

  // const useStyle = useMemo(() => {
  // 	return (mobileHeader == null && { visibility: 'hidden' }) || mobileHeader
  // 		? { visibility: 'hidden' }
  // 		: { visibility: 'initial' };
  // }, [mobileHeader]);

  const renderHeader = () => {
    return (
      <div className="authing-pc-header-display">
        {hasNotice && <Notice></Notice>}
        <header className={clssmode}>
          <div className="warpper basic-column">
            <DownloadLogoFile
              isDownloadLogoFileShow={isDownloadLogoFileShow}
              cancel={() => setIsDownloadLogoFileShow(false)}
              title={t("common.tool-package.toolTip.title")}
              image={
                "//files.authing.co/authing-website/download-authing-logo.png"
              }
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Link
                className="logo"
                style={{ marginRight: 30 }}
                to="/"
                onContextMenu={(event) => {
                  event.preventDefault();
                  setIsDownloadLogoFileShow(!isDownloadLogoFileShow);
                }}
                data-log="header/logo"
              >
                {!special && mode === "light" && y < 10 ? (
                  <img
                    src={
                      "//files.authing.co/authing-website/authing-logo-white.png"
                    }
                    alt=""
                  />
                ) : (
                  <img
                    src={
                      "//files.authing.co/authing-website/authing-logo-0830.png"
                    }
                    alt=""
                  />
                )}
              </Link>
              <div className="nav">
                {menu.map((item, index) => {
                  const cls = classnames({
                    "nav-item": true,
                    selected: activeKey === item.key,
                    "nav-with-submenus": item.children && item.children.length,
                  });
                  return (
                    <div key={index} className={cls}>
                      {item.url ? (
                        item.key === "Demo" ? (
                          <a
                            className="nav-link"
                            href={item.url}
                            target="blank"
                          >
                            {item.title}
                            <i
                              className="icon authing-icon authing-hot2 new-icon"
                              style={{
                                color: "#E63333",
                                marginLeft: 2,
                              }}
                            ></i>
                          </a>
                        ) : (
                          <Link
                            to={item.url}
                            className="nav-link"
                            data-log={item.log}
                          >
                            {item.title}
                          </Link>
                        )
                      ) : (
                        <span className="nav-product">{item.title}</span>
                      )}
                      {item.children && item.children.length && (
                        <div
                          className="item-block"
                          style={{
                            ...item.subMenuStyle,
                          }}
                        >
                          {item.key === "product" && (
                            <div className="extra-block">
                              {renderProductExtra()}
                            </div>
                          )}

                          {item.key === "solution" && (
                            <div className="extra-block">
                              {renderSolutionExtra()}
                            </div>
                          )}
                          <div className="submenus-block-warp">
                            {item.children.map((child, index) => {
                              return (
                                <div
                                  key={`${child.type}-${index}`}
                                  className={classnames(
                                    "submenus-block",
                                    `submenus-block-${item.key}`
                                  )}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      height: "100%",
                                    }}
                                  >
                                    <div>
                                      {/* {child.type && <div className="type-name">{child.type}</div>} */}
                                      <div className="type-name">
                                        {child.type}
                                      </div>
                                      {child.submenus.map((sub, index) => (
                                        <div
                                          key={`${sub.url}-${index}`}
                                          data-log={sub.log}
                                        >
                                          {onPageClickLink(sub)}
                                          {/* {sub.descript && (
                                            <div className="sub-item-descirpt">
                                              {sub.descript}
                                            </div>
                                          )} */}
                                        </div>
                                      ))}
                                    </div>
                                    {child.line && (
                                      <div className="submenus-block-line"></div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          {item.key === "case" && (
                            <div className="extra-block">
                              {renderCaseExtra()}
                            </div>
                          )}
                          {item.key === "developer" && (
                            <div className="extra-block">
                              {renderDeveloperExtra2()}
                            </div>
                          )}
                          {item.key === "about" && (
                            <div className="extra-block">
                              {renderAboutExtra()}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="options">
              <div className="head-switch-lang">
                <i className="icon authing-icon authing-language"></i>
                <select
                  name="lang"
                  onChange={change}
                  value={lang}
                  data-log="header/language"
                >
                  {langs.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <i className="icon authing-icon authing-expand_more_black_24dp icon-style"></i>
              </div>
              <div className="console">
                <span
                  className="contact-text"
                  data-log="header/quotation"
                  onClick={() => {
                    window.open(
                      "https://www.authing.cn/authingform?fromTag=导航栏"
                    );
                  }}
                >
                  {t("common.button.consult")}
                </span>
                {/* <CommonConsult
                  listenLocation={true}
                  aside={
                   
                  }
                /> */}
              </div>
              {user ? (
                <div className="user-box">
                  <div className="user-img">
                    <img src={avatarImg} alt="avatar" />
                  </div>
                  <div className="user-options">
                    <div className="item" onClick={tryNow}>
                      {t("common.nav.nav-console")}
                    </div>
                    <div
                      className="item"
                      onClick={() => {
                        window.location.href = "https://console.authing.cn/u";
                      }}
                    >
                      {t("common.nav.nav-personal")}
                    </div>
                    <div
                      className="item"
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      {t("common.nav.nav-logout")}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={classnames("login")}
                  onClick={tryNow}
                  data-log="header/login"
                >
                  {t("common.nav.nav-login")}
                </div>
              )}
            </div>
          </div>
        </header>
      </div>
    );
  };

  return (
    <>
      <MobileHeader y={y} mode={mode} menu={menuMobile} user={user} />
      {renderHeader()}
    </>
  );
};
